import { render } from "./ContactUsPage.vue?vue&type=template&id=1d46522e&scoped=true"
import script from "./ContactUsPage.vue?vue&type=script&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&lang=js"

import "./ContactUsPage.vue?vue&type=style&index=0&id=1d46522e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d46522e"]])

export default __exports__